const Animate = {
    base($ele) {
        if($ele.children().length) {
            // $ele.children().each((i, obj) => {});
            let childs = $ele.children();
            TweenMax.set(childs, {y:60, opacity:0});
            TweenMax.staggerTo(childs, 0.5, {y:0, opacity:1, ease:Quad.easeOut}, 0.15);
            $ele.css('opacity', 1);
        }else{
            TweenMax.set($ele, {y: 50});
            TweenMax.to($ele, 0.4, {y:0, opacity:1, ease:Power3.easeOut});
        }
    },
    zoom($ele) {
        TweenMax.set($ele, {scale: 1.2, rotation:-25});
        TweenMax.to($ele, 0.6, {scale:1, rotation:0, opacity:1, ease: Back.easeInOut});
    }
};

const InViewAnime = {
    play($ele) {
        if($ele.data('is-play')) return;
        const type = $ele.data('in-view');
        if(type === '') {
            Animate.base($ele);
        }else if(type === 'none'){
            //
        }else{
            if(Animate.hasOwnProperty(type)) {
                Animate[type]($ele);
            }
        }
        $ele.data('is-play', true);
    }
};

export default InViewAnime;